document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll("[data-wcu-accordion]");
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll("[data-wcu-item]");
    if (!items.length) return;

    items.forEach((item) => {
      const toggle = item.querySelector(".wcu-toggle");
      const body = item.querySelector(".wcu-body");
      if (!toggle || !body) return;

      // If item is active from Liquid, set initial height
      if (item.classList.contains("is-active")) {
        body.style.maxHeight = body.scrollHeight + "px";
      }

      toggle.addEventListener("click", () => {
        const isActive = item.classList.contains("is-active");

        // Close all first
        items.forEach((other) => {
          const otherBody = other.querySelector(".wcu-body");
          const otherToggle = other.querySelector(".wcu-toggle");
          if (!otherBody || !otherToggle) return;

          other.classList.remove("is-active");
          otherBody.style.maxHeight = null;
          otherToggle.setAttribute("aria-expanded", "false");
        });

        // If the clicked one was not active, open it
        if (!isActive) {
          item.classList.add("is-active");
          body.style.maxHeight = body.scrollHeight + "px";
          toggle.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
});
